import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Store } from '@ngrx/store';
import {EntityChartState} from '../../store/reducers/entity-chart.reducer';
import {EntityDataTemplateDownloadAction, EntityUploadSourceFileAction} from '../../store/actions/entity-chart.actions';
import { CombineRoute } from '@shared/constants/RelativePath';
import {Location} from '@angular/common';

@Component({
    standalone: false,
    selector     : 'lib-app-import-entities',
  templateUrl  : './entity-chart-import.component.html',
  styleUrls    : ['./entity-chart-import.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EntityChartImportComponent implements OnInit {
  FileToUpload: File;
  ImportFile: { name: string };
  ReplaceExistingSelection: boolean;
  horizontalStepperStep1: any; // TODO: nahid did this for build fix, please revisit (1st step ctrl of the wizard)
  // Horizontal Stepper
  Form: FormGroup;
  FormErrors: any;

  constructor (private router: Router,
               private formBuilder: FormBuilder,
               private store: Store<EntityChartState>,
               private activatedRoute: ActivatedRoute,
               private location: Location) {
    this.ImportFile = {
      name: 'Entity Data Template (.xlsx)'
    };
    this.ReplaceExistingSelection = false;
    // Horizontal Stepper form error
    this.FormErrors = {
      selectedFile            : {},
      replaceExistingSelection: {}
    };
  }

  ngOnInit () {

    // Horizontal Stepper form steps
    this.Form = this.formBuilder.group({
      selectedFile            : ['', Validators.required],
      replaceExistingSelection: [false]
    });

    this.Form.valueChanges.subscribe(() => {
      this.onFormValuesChanged();
    });
  }

  onFormValuesChanged () {
    for (const field in this.FormErrors) {
      if (!this.FormErrors.hasOwnProperty(field)) {
        continue;
      }

      // Clear previous errors
      this.FormErrors[field] = {};

      // Get the control
      const control = this.Form.get(field);

      if (control && control.dirty && !control.valid) {
        this.FormErrors[field] = control.errors;
      }
    }
  }

  cancel () {
    this.location.back();
  }
  done () {
    this.store.dispatch(new EntityUploadSourceFileAction(this.FileToUpload, this.Form.get('replaceExistingSelection').value));
  }

  downloadEntityDataTemplate() {
    this.store.dispatch(new EntityDataTemplateDownloadAction('Entity Data Template.xlsx'));
  }
}
